import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_OnlineBipolarTest = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_OnlineBipolarTest' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><h3>Online Bipolar Test</h3></p>
                <p className='w-750'>This online bipolar test (Goldberg Bipolar Screening Test) can help determine whether you might have the symptoms of bipolar disorder (Bipolar I or II). Use the results to decide if you need to see a doctor or other mental health professional to further discuss diagnosis and treatment of adult bipolar disorder.
                    <br/><br/>
                    <b>Instructions:</b>This online bipolar test is designed to screen for the possibility of a disorder in the bipolar spectrum in individuals, 18 or older, who have had at least one depression severe enough to have caused them distress and/or interfered with their functioning at home, work, school or in their interpersonal relationships.
                    <br/><br/>
                    The items below refer to how you have felt and behaved over much of your life. If you have usually been one way, and have recently changed, your responses should reflect how you have USUALLY been.</p>

                
               

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>1. At times I am much more talkative or speak much faster than usual.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesIAmMuchMoreTalkativeSpeak_1' name='rbAtTimesIAmMuchMoreTalkativeSpeak' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesIAmMuchMoreTalkativeSpeak_2' name='rbAtTimesIAmMuchMoreTalkativeSpeak' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesIAmMuchMoreTalkativeSpeak_3' name='rbAtTimesIAmMuchMoreTalkativeSpeak' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesIAmMuchMoreTalkativeSpeak_4' name='rbAtTimesIAmMuchMoreTalkativeSpeak' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesIAmMuchMoreTalkativeSpeak_5' name='rbAtTimesIAmMuchMoreTalkativeSpeak' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesIAmMuchMoreTalkativeSpeak_6' name='rbAtTimesIAmMuchMoreTalkativeSpeak' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2. There have been times when I was much more active or did many more things than usual.
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenWasMuch_1' name='rbThereHaveBeenTimesWhenWasMuch' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenWasMuch_2' name='rbThereHaveBeenTimesWhenWasMuch' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenWasMuch_3' name='rbThereHaveBeenTimesWhenWasMuch' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenWasMuch_4' name='rbThereHaveBeenTimesWhenWasMuch' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenWasMuch_5' name='rbThereHaveBeenTimesWhenWasMuch' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenWasMuch_6' name='rbThereHaveBeenTimesWhenWasMuch' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>3. I get into moods where I feel very speeded up or irritable.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIGetIntoMoodsWhereFeelVerySpeeded_1' name='rbIGetIntoMoodsWhereFeelVerySpeeded' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIGetIntoMoodsWhereFeelVerySpeeded_2' name='rbIGetIntoMoodsWhereFeelVerySpeeded' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIGetIntoMoodsWhereFeelVerySpeeded_3' name='rbIGetIntoMoodsWhereFeelVerySpeeded' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIGetIntoMoodsWhereFeelVerySpeeded_4' name='rbIGetIntoMoodsWhereFeelVerySpeeded' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIGetIntoMoodsWhereFeelVerySpeeded_5' name='rbIGetIntoMoodsWhereFeelVerySpeeded' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIGetIntoMoodsWhereFeelVerySpeeded_6' name='rbIGetIntoMoodsWhereFeelVerySpeeded' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>4. There have been times when I have felt both high (elated) and low (depressed) at the same time.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed_1' name='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed_2' name='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed_3' name='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed_4' name='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed_5' name='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed_6' name='rbThereHaveBeenTimesWhenIHaveFeltBothHighElatedDepressed' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>5. At times, I have been much more interested in sex than usual.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimeHaveBeenMuchMoreInterested_1' name='rbAtTimeHaveBeenMuchMoreInterested' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimeHaveBeenMuchMoreInterested_2' name='rbAtTimeHaveBeenMuchMoreInterested' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimeHaveBeenMuchMoreInterested_3' name='rbAtTimeHaveBeenMuchMoreInterested' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimeHaveBeenMuchMoreInterested_4' name='rbAtTimeHaveBeenMuchMoreInterested' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimeHaveBeenMuchMoreInterested_5' name='rbAtTimeHaveBeenMuchMoreInterested' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimeHaveBeenMuchMoreInterested_6' name='rbAtTimeHaveBeenMuchMoreInterested' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>6. My self-confidence ranges from great self-doubt to equally great overconfidence.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMySelfConfidenceRangesFromGreatSelf_1' name='rbMySelfConfidenceRangesFromGreatSelf' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMySelfConfidenceRangesFromGreatSelf_2' name='rbMySelfConfidenceRangesFromGreatSelf' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMySelfConfidenceRangesFromGreatSelf_3' name='rbMySelfConfidenceRangesFromGreatSelf' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMySelfConfidenceRangesFromGreatSelf_4' name='rbMySelfConfidenceRangesFromGreatSelf' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMySelfConfidenceRangesFromGreatSelf_5' name='rbMySelfConfidenceRangesFromGreatSelf' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMySelfConfidenceRangesFromGreatSelf_6' name='rbMySelfConfidenceRangesFromGreatSelf' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>7. There have been GREAT variations in the quantity or quality of my work.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenGreatVariationsQuantity_1' name='rbThereHaveBeenGreatVariationsQuantity' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenGreatVariationsQuantity_2' name='rbThereHaveBeenGreatVariationsQuantity' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenGreatVariationsQuantity_3' name='rbThereHaveBeenGreatVariationsQuantity' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenGreatVariationsQuantity_4' name='rbThereHaveBeenGreatVariationsQuantity' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenGreatVariationsQuantity_5' name='rbThereHaveBeenGreatVariationsQuantity' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThereHaveBeenGreatVariationsQuantity_6' name='rbThereHaveBeenGreatVariationsQuantity' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>8. For no apparent reason I sometimes have been VERY angry or hostile.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbForNoApparentReasonSometimeHaveBeen_1' name='rbForNoApparentReasonSometimeHaveBeen' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbForNoApparentReasonSometimeHaveBeen_2' name='rbForNoApparentReasonSometimeHaveBeen' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbForNoApparentReasonSometimeHaveBeen_3' name='rbForNoApparentReasonSometimeHaveBeen' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbForNoApparentReasonSometimeHaveBeen_4' name='rbForNoApparentReasonSometimeHaveBeen' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbForNoApparentReasonSometimeHaveBeen_5' name='rbForNoApparentReasonSometimeHaveBeen' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbForNoApparentReasonSometimeHaveBeen_6' name='rbForNoApparentReasonSometimeHaveBeen' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>9. I have periods of mental dullness and other periods of very creative thinking.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHavePeriodsOfMentalDullnessAndOtherPeriods_1' name='rbIHavePeriodsOfMentalDullnessAndOtherPeriods' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHavePeriodsOfMentalDullnessAndOtherPeriods_2' name='rbIHavePeriodsOfMentalDullnessAndOtherPeriods' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHavePeriodsOfMentalDullnessAndOtherPeriods_3' name='rbIHavePeriodsOfMentalDullnessAndOtherPeriods' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHavePeriodsOfMentalDullnessAndOtherPeriods_4' name='rbIHavePeriodsOfMentalDullnessAndOtherPeriods' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHavePeriodsOfMentalDullnessAndOtherPeriods_5' name='rbIHavePeriodsOfMentalDullnessAndOtherPeriods' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHavePeriodsOfMentalDullnessAndOtherPeriods_6' name='rbIHavePeriodsOfMentalDullnessAndOtherPeriods' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>10. At times I am greatly interested in being with people and at other times I just want to be left alone with my thoughts.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesAmGreatlyInterestedInBeingWithPeople_1' name='rbAtTimesAmGreatlyInterestedInBeingWithPeople' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesAmGreatlyInterestedInBeingWithPeople_2' name='rbAtTimesAmGreatlyInterestedInBeingWithPeople' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesAmGreatlyInterestedInBeingWithPeople_3' name='rbAtTimesAmGreatlyInterestedInBeingWithPeople' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesAmGreatlyInterestedInBeingWithPeople_4' name='rbAtTimesAmGreatlyInterestedInBeingWithPeople' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesAmGreatlyInterestedInBeingWithPeople_5' name='rbAtTimesAmGreatlyInterestedInBeingWithPeople' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbAtTimesAmGreatlyInterestedInBeingWithPeople_6' name='rbAtTimesAmGreatlyInterestedInBeingWithPeople' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>11. I have had periods of great optimism and other periods of equally great pessimism.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods_1' name='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods_2' name='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods_3' name='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods_4' name='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods_5' name='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods_6' name='rbIHaveHadPeriodsOfGreatOptimismAndOtherPeriods' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>12. I have had periods of tearfulness and crying and other times when I laugh and joke excessively.
                                </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther_1' name='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther_2' name='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther_3' name='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther_4' name='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther_5' name='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther_6' name='rbIHaveHadPeriodsOfTearFulnessAndCryingAndOther' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                
























            </div>
        </form>

    )
}   